
import AppCustomLangSelect from "@/components/CustomLanguageSelect.vue";
import AppStyleEditor from "@/components/layout-editor/StyleEditor.vue";
import AppFieldEdit from "@/components/sale-layout-editor/FieldEdit.vue";
import { PropSelectGroup } from "@/utils/prop-select/prop-select-group";
import { getSaleMapPropSelectGroup } from "@/utils/prop-select/sale-map-prop-group";
import { Field } from "@/utils/documents/field";
import Vue from "vue";

export default Vue.extend({
	data() {
		return{
			selectedLang: "",
			toEditStyleProp: null as null | Field,
			toEditProp: null as null | Field,
		};
	},
	props: {
		line: Array as () => Field[],
		title: String,
		newItemConstructor: Function
	},
	computed: {
		saleMapPropSelectGroup():PropSelectGroup{
			return getSaleMapPropSelectGroup();
		}
	},
	methods: {
		addItemClicked() {
			let newItem = new Field();
			if (this.newItemConstructor){
				newItem = this.newItemConstructor();
			}
			this.line.push(newItem);
		},
		removeItem(index: number) {
			this.line.splice(index, 1);
		},
		editStyle(style: Field) {
			this.toEditStyleProp = style;
		},
		editProp(prop: Field) {
			this.toEditProp = prop;
		},
		getPropValue(prop: Field): string {
			if (!prop.Prop) return "";
			let val = this.saleMapPropSelectGroup.getPropSelectFromValue(prop.Prop);
			if (!val) return "";
			return val.text.toString();;
		}
	},
	components: {
		AppCustomLangSelect,
		AppStyleEditor,
		AppFieldEdit
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
